"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var propTypes = {
    steps: PropTypes.arrayOf(PropTypes.node).isRequired,
    activeStepIndex: PropTypes.number.isRequired,
    goToStepByIndex: PropTypes.func
};
/**
 * The `StepNavigation` component indicates the user's progress within a
 * certain workflow.
 * Usually the component is used within a tariff calculation wizard. In the
 * first step the user might provide his personal information, in the second
 * step his address information, in the third step the bank account data and in
 * the last step the user can sign an insurance policy with the help of a
 * [SalesmanButton](#!/SalesmanButton).
 *
 * The user can navigate back to already completed steps.
 * The callback funtion `goToStepByIndex` should be passed as a prop and listen
 * for step changes.
 */
var StepNavigation = /** @class */ (function (_super) {
    __extends(StepNavigation, _super);
    function StepNavigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goToStep = function (event) {
            var goToStepByIndex = _this.props.goToStepByIndex;
            if (typeof goToStepByIndex !== 'function') {
                return;
            }
            var index = Number(event.currentTarget.getAttribute('data-index'));
            goToStepByIndex(index);
        };
        return _this;
    }
    StepNavigation.prototype.renderStep = function (step, index) {
        var goToStepByIndex = this.props.goToStepByIndex;
        var hasGoToStepByIndexHandler = typeof goToStepByIndex === 'function';
        var activeStepIndex = Math.max(0, this.props.activeStepIndex);
        var done = activeStepIndex > index;
        var active = activeStepIndex === index;
        var stepClassName = classNames('ee_step-navigation__step', {
            'ee_step-navigation__step--active': active
        });
        var buttonClassName = classNames('ee_step-navigation__button', {
            'ee_step-navigation__button--has-handler': hasGoToStepByIndexHandler
        });
        return (React.createElement("li", { key: "step-" + index, className: stepClassName },
            React.createElement("button", { type: "button", className: buttonClassName, disabled: !done || !hasGoToStepByIndexHandler, onClick: this.goToStep, "data-index": index },
                React.createElement("span", { className: 'ee_step-navigation__label' }, step))));
    };
    StepNavigation.prototype.renderSteps = function () {
        var _this = this;
        return this.props.steps.map(function (step, index) {
            return _this.renderStep(step, index);
        });
    };
    StepNavigation.prototype.render = function () {
        var className = this.props.className;
        var componentClassName = classNames(className, 'ee_step-navigation', {
            'ee_step-navigation--all-checked': this.isCompletelyChecked()
        });
        return React.createElement("ol", { className: componentClassName }, this.renderSteps());
    };
    StepNavigation.prototype.isCompletelyChecked = function () {
        var activeStepIndex = Math.max(0, this.props.activeStepIndex);
        var steps = this.props.steps.length;
        return activeStepIndex >= steps;
    };
    StepNavigation.propTypes = propTypes;
    StepNavigation.defaultProps = {
        steps: [],
        activeStepIndex: 0,
        goToStepByIndex: undefined
    };
    return StepNavigation;
}(react_1.Component));
exports.StepNavigation = StepNavigation;
exports.default = StepNavigation;
//# sourceMappingURL=StepNavigation.js.map
